<template>
  <div class="main-content">

    <EmptyCardModal
      v-if="modalData"
      ref="cashOutModal"
      :modalData="modalData"
      :onModalClose="(reset) => modalData = null"
      :onModalAccept="addCashOut"
    >
      <slot>
        <div>
          <p>Обналичить карту <strong>{{ modalData.card.number }}</strong></p>
          <div class="form-group">
            <label>Сумма для обналичивания</label>
            <input type="number" v-model="modalData.amount" class="form-control">
          </div>
        </div>
      </slot>
    </EmptyCardModal>

    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading && cards">

          <div class="text-right">
            <button @click="() => getRecords()" class="btn btn-outline-info">Обновить</button>
          </div>

          <table class="table table-sm table-hover mt-1">
            <thead>
            <tr>
              <th></th>
              <th>Номер</th>
              <th>Баланс</th>
              <th>Сбор</th>
              <th>Поступление</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(c,id, i) in cards" :class="{mark: c.balance > 45000}">
              <td>{{ i + 1 }}</td>
              <td>({{ c.id }}) {{ c.number }}</td>
              <td>{{ c.balance }}</td>
              <td><span v-if="c.balance_date">{{ printDate(c.balance_date) }}</span></td>
              <td><span v-if="c.last_transaction">{{ printDate(c.last_transaction) }}</span></td>
              <td>
                <button @click="cashOutCard(c)" class="btn btn-outline-success btn-xs">обналичить</button>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>

    <div class="card" v-if="cashout">
      <div class="card-header">
        <h5>История</h5>
      </div>
      <div class="card-body">
        <table class="table table-sm mt-1 table-hover">
          <thead>
          <tr>
            <th>ID</th>
            <th>Карта</th>
            <th>Сумма</th>
            <th>Дата</th>
            <th>userId</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="c in cashout">
            <td>{{ c.id }}</td>
            <td>({{ c.card_id }}) {{ cards && cards[c.card_id]?.number }}</td>
            <td>{{ c.amount }}</td>
            <td>{{ printDate(c.created_at) }}</td>
            <td>{{ c.user_id }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import EmptyCardModal from "@/components/modals/EmptyCardModal.vue";

export default {
  components: {
    LoadingButton,
    EmptyCardModal,
  },
  data() {
    return {
      loading: false,
      cards: null,
      cashout: null,
      modalData: null,
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    cashOutCard(card) {
      this.modalData = {
        card,
      }
    },
    async addCashOut() {
      if (!this.modalData.amount || +this.modalData.amount <= 0) {
        toastr['warning']('Укажите сумму снятия');
        return;
      }
      this.$refs.cashOutModal.acceptBtnLoading = true;
      const {data} = await api.post('/cards/cardCashOut', {
        card_id: this.modalData.card.id,
        amount: this.modalData.amount
      });
      if (data.success) {
        toastr['success']('Сохранено');
        this.modalData = null;
        this.getRecords(true);
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.$refs.cashOutModal.acceptBtnLoading = false;
    },
    async getRecords(silent = false) {
      this.loading = !silent;
      this.cards = null;
      const {data} = await api.index('/cards/status');
      if (data.success) {
        this.cards = data.cards.reduce((acc, c) => {
          acc[c.id] = c;
          return acc;
        }, {})
        if (data.freshCashOut) {
          data.freshCashOut.forEach((c) => {
            this.cards[c.card_id].balance -= c.amount;
          })
        }
        this.cashout = data.cashout;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;

    }
  }
}

</script>
